module.exports = __webpack_public_path__ + "static/media/success.f544fcf9.webp";